import styled from "styled-components";
import { Link } from "react-router-dom";
//import { FaFacebook, FaInstagram, FaPinterest } from "react-icons/fa";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>Chandelier Luxe</h3>
          <p>Illuminating spaces with timeless beauty</p>
          {/*<SocialLinks>
            <a href="https://facebook.com">
              <FaFacebook />
            </a>
            <a href="https://instagram.com">
              <FaInstagram />
            </a>
            <a href="https://pinterest.com">
              <FaPinterest />
            </a>
          </SocialLinks>*/}
        </FooterSection>

        <FooterSection>
          <h4>Quick Links</h4>
          <FooterLink to="/products">Products</FooterLink>
          <FooterLink to="/about">About Us</FooterLink>
          <FooterLink to="/contact">Contact</FooterLink>
        </FooterSection>

        <FooterSection>
          <h4>Contact Info</h4>
          <p>Phone: (+27) 84 422 9825</p>
          <p>Email: info@chandelierluxe.co.za</p>
        </FooterSection>
      </FooterContent>
      <Copyright>
        © {new Date().getFullYear()} Chandelier Luxe. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background: ${(props) => props.theme.colors.secondary};
  padding: 4rem 2rem 1rem 2rem;
  margin-top: 4rem;
`;

const FooterContent = styled.div`
  max-width: ${(props) => props.theme.maxWidth};
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  h3,
  h4 {
    color: ${(props) => props.theme.colors.accent};
    margin-bottom: 1.5rem;
  }

  p {
    margin-bottom: 0.5rem;
  }
`;

/*const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  a {
    font-size: 1.5rem;

    &:hover {
      color: ${(props) => props.theme.colors.accent};
    }
  }
`;*/

const FooterLink = styled(Link)`
  display: block;
  margin-bottom: 0.5rem;
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export default Footer;
